import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PlaceBidBtn',
  emits: ["placeBid"],
  setup(__props, { emit: __emit }) {

  const emit = __emit;

  const placeBid = () => {
    emit("placeBid");
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "btn btn-blue btn-fast-bid-confirm",
    onClick: placeBid
  }, _toDisplayString(_unref(trans)("lot.confirmation.buttons.confirm_bid")), 1))
}
}

})